import dynamic from 'next/dynamic';
import { EventSearchProps } from './EventSearch.types';

export const EventSearch = dynamic<{ model: EventSearchProps }>(() =>
  import('./EventSearch').then(mod => mod.EventSearch)
);
